import { Icon } from "source/shared/components/Icon/Icon"
import { Link } from "react-router-dom"
import { css } from "@emotion/react"
import { useGivingPersonContext } from "../../hooks/useGivingPersonContext"

export default function GivingProfileLinks() {
  const { givingPerson } = useGivingPersonContext()

  const iconCss = css`
    width: 24px;
    height: 24px;
    fill: var(--color-tint4);
  `

  const chevronCss = css`
    width: 16px;
    height: 16px;
    fill: var(--color-tint4);
  `

  const linkClassName = "d-f ai-c jc-sb w-100% c-tint1 fw-500"
  const linkCss = css`
    border-bottom: 1px solid var(--color-tint6);
    padding: 12px 6px;
  `

  return (
    <div className="d-n@md d-f mt-2">
      <nav className="w-100%">
        {givingPerson.can_view_text2give_settings && (
          <Link
            className={linkClassName}
            to="/giving/profile/text-to-give"
            css={linkCss}
          >
            <div className="d-f ai-c">
              <Icon
                symbol="general#mobile-phone"
                css={iconCss}
                aria-hidden="true"
              />
              <span className="ml-1">Text2Give</span>
            </div>
            <Icon
              symbol="general#right-chevron"
              css={chevronCss}
              aria-hidden="true"
            />
          </Link>
        )}
        <Link
          className={linkClassName}
          to="/giving/profile/notifications"
          css={linkCss}
        >
          <div className="d-f ai-c">
            <Icon
              symbol="churchCenter#bell-o"
              css={iconCss}
              aria-hidden="true"
            />
            <span className="ml-1">Notifications</span>
          </div>
          <Icon
            symbol="general#right-chevron"
            css={chevronCss}
            aria-hidden="true"
          />
        </Link>
        <Link
          className={linkClassName}
          to="/giving/profile/statements"
          css={linkCss}
        >
          <div className="d-f ai-c">
            <Icon
              symbol="churchCenter#giving-statements-o"
              css={iconCss}
              aria-hidden="true"
            />
            <span className="ml-1">Statements</span>
          </div>
          <Icon
            symbol="general#right-chevron"
            css={chevronCss}
            aria-hidden="true"
          />
        </Link>
      </nav>
    </div>
  )
}
